export const getCardType = (cardNumber) => {
    if (!cardNumber) {
        return 'none';
    }
    switch (cardNumber[0]) {
        case '3':
            if (['4', '7'].includes(cardNumber[1])) {
                return 'american_express';
            }
            return 'none';
        case '4':
            return 'visa';
        case '5':
            return 'master_card';
        case '6':
            return 'discover';
    }
    return 'none';
};
